import { render, staticRenderFns } from "./erweima.vue?vue&type=template&id=283760a2&scoped=true&"
import script from "./erweima.vue?vue&type=script&lang=js&"
export * from "./erweima.vue?vue&type=script&lang=js&"
import style0 from "./erweima.vue?vue&type=style&index=0&id=283760a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283760a2",
  null
  
)

export default component.exports